import { Injectable, inject } from '@angular/core';
import { Auth, IdTokenResult, User, authState } from '@angular/fire/auth';
import { CanActivate, Router, UrlTree } from '@angular/router';
import Debug from 'debug';
import { Observable, from, mergeMap, of } from 'rxjs';
const debug = Debug('aumico:AuthGuard');
@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    private readonly auth: Auth = inject(Auth);
    private readonly authState$ = authState(this.auth);
    constructor(private readonly router: Router) { }
    canActivate(): Observable<boolean | UrlTree> {
        const language = localStorage.getItem('currentLanguage');
        const loginUrl = this.router.parseUrl(`${language}/auth/login`);
        return this.authState$.pipe(
            mergeMap((user: User) => {
                if (user != null) {
                    return from(user.getIdTokenResult());
                } else {
                    console.log('AuthGuard: user is not logged in', loginUrl);
                    return of(loginUrl);
                }
            }),
            mergeMap((result: UrlTree | IdTokenResult) => {
                if (result instanceof UrlTree) {
                    return of(result);
                }
                if (result.claims['roles'] === undefined) {
                    console.warn('User has no roles defined in claims, redirecting to login.');
                    return of(loginUrl);
                }

                const roles = result.claims['roles'] as string[];

                if (
                    roles.includes('ORG_USER') ||
                    roles.includes('ORG_ADMIN') ||
                    roles.includes('ORG_VIEWER')
                ) {
                    return of(true);
                }
                return of(loginUrl);
            }),
        );
    }
}
